var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectmanagement3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3106.72 2959.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{opacity:0.53;}.cls-11,.cls-21,.cls-22,.cls-3{fill:#fff;}.cls-4{fill:#bdd0fb;}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:#7d97f4;}.cls-11{opacity:0.56;}.cls-12{fill:url(#linear-gradient-7);}.cls-13{fill:url(#linear-gradient-8);}.cls-14{fill:url(#linear-gradient-9);}.cls-15{fill:url(#linear-gradient-10);}.cls-16{fill:#91b3fa;}.cls-17{fill:#2b69b3;}.cls-18{fill:url(#linear-gradient-11);}.cls-19{fill:url(#linear-gradient-12);}.cls-20{fill:url(#linear-gradient-13);}.cls-21{opacity:0.78;}.cls-22{opacity:0.49;}.cls-23{fill:#18174a;}.cls-24{fill:url(#linear-gradient-14);}.cls-25{fill:url(#linear-gradient-15);}.cls-26{fill:url(#linear-gradient-16);}.cls-27{fill:url(#linear-gradient-17);}.cls-28{fill:url(#linear-gradient-18);}.cls-29{fill:url(#linear-gradient-19);}.cls-30{fill:url(#linear-gradient-20);}.cls-31{fill:url(#linear-gradient-21);}.cls-32{fill:url(#linear-gradient-22);}.cls-33{fill:url(#linear-gradient-23);}.cls-34{fill:url(#linear-gradient-24);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3048.52,
    y1: 3167.71,
    x2: 1069.91,
    y2: 1032.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2019.05,
    y1: 1836.51,
    x2: 2587.38,
    y2: 1836.51,
    gradientTransform: "translate(-716.96 473.12) rotate(-20.18)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2615.01,
    y1: 1686.83,
    x2: 2648.2,
    y2: 1686.83,
    gradientTransform: "translate(-716.96 473.12) rotate(-20.18)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2787.28,
    y1: 1940.46,
    x2: 2810.06,
    y2: 1940.46,
    gradientTransform: "translate(-716.96 473.12) rotate(-20.18)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2229.54,
    y1: 2199.53,
    x2: 2814.93,
    y2: 2199.53,
    gradientTransform: "translate(-716.96 473.12) rotate(-20.18)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2171.19,
    y1: 2322.9,
    x2: 2203.96,
    y2: 2322.9,
    gradientTransform: "translate(-716.96 473.12) rotate(-20.18)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1680.99,
    y1: 2309.83,
    x2: 1697.18,
    y2: 2309.83,
    gradientTransform: "translate(-716.96 473.12) rotate(-20.18)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1674.43,
    y1: 2127.85,
    x2: 1991.92,
    y2: 2127.85,
    gradientTransform: "translate(-716.96 473.12) rotate(-20.18)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1816.11,
    y1: 2432.22,
    x2: 2178.48,
    y2: 2432.22,
    gradientTransform: "translate(-716.96 473.12) rotate(-20.18)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1776.28,
    y1: 2454.87,
    x2: 1801.06,
    y2: 2454.87,
    gradientTransform: "translate(-716.96 473.12) rotate(-20.18)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1507.35,
    y1: 2535.22,
    x2: 1385.91,
    y2: 1169.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1368.92,
    y1: 1909.41,
    x2: 1412.53,
    y2: 3294.88,
    gradientTransform: "translate(145.01 24.7) rotate(-0.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1128.72,
    y1: 1916.98,
    x2: 1172.33,
    y2: 3302.44,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -2805.29,
    y1: 1056.17,
    x2: -2617.15,
    y2: 1484.24,
    gradientTransform: "matrix(-0.98, -0.21, -0.21, 0.98, -1629.54, -189.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -2458.6,
    y1: 3215.09,
    x2: -2334.33,
    y2: 1762.62,
    gradientTransform: "matrix(-1, 0, 0, 1, -1814.97, 0)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -2208.61,
    y1: 3236.7,
    x2: -2084.31,
    y2: 1783.85,
    gradientTransform: "matrix(-1, 0, 0, 1, -1814.97, 0)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -2472.23,
    y1: 1783.39,
    x2: -2448.89,
    y2: 1612.6,
    gradientTransform: "matrix(-1, 0, 0, 1, -1814.97, 0)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 174.1,
    y1: 1945.68,
    x2: 701.17,
    y2: 1725.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -2639.97,
    y1: 1257.69,
    x2: -2436.28,
    y2: 895.18,
    gradientTransform: "matrix(-0.98, -0.19, -0.19, 0.98, -1646.35, -168.9)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -2596.61,
    y1: 1282.05,
    x2: -2392.92,
    y2: 919.55,
    gradientTransform: "matrix(-0.98, -0.19, -0.19, 0.98, -1646.35, -168.9)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -2842.47,
    y1: 1072.51,
    x2: -2654.33,
    y2: 1500.58,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 999.04,
    y1: 1319.35,
    x2: 1049.7,
    y2: 1319.35,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 639.43,
    y1: 1822.63,
    x2: 736.24,
    y2: 1822.63,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -484.56,
    y1: 4728.73,
    x2: -536.4,
    y2: 5284.89,
    gradientTransform: "translate(-1504.02 3817.74) rotate(-135)",
    xlinkHref: "#linear-gradient-11"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2772.79,1950.69c-271.88,635.48-989.54,908.43-1551.84,861.89-153.53-12.71-462.44-38.27-703.64-266.37-463.2-438-391.87-1353.66,51.55-1892.72C626,584.07,1021.23,119,1637.16,125.18c451,4.56,767.48,259.3,806,291,48.62,40.09,155.86,135.35,252.51,286.49C2922.72,1057.83,2942.68,1553.58,2772.79,1950.69Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 135.43,
    y: 1557.13,
    width: 297.57,
    height: 1205.82
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 521.49,
    y: 1557.13,
    width: 297.57,
    height: 1205.82
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 933.16,
    y: 1557.13,
    width: 297.57,
    height: 1205.82
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1343.88,
    y: 1557.13,
    width: 297.57,
    height: 1205.82
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1754.59,
    y: 1557.13,
    width: 297.57,
    height: 1205.82
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2170.68,
    y: 1557.13,
    width: 297.57,
    height: 1205.82
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2579.81,
    y: 1557.13,
    width: 297.57,
    height: 1205.82
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 135.43,
    y: 2467.22,
    width: 295.74,
    height: 295.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 522.41,
    y: 2347.77,
    width: 295.74,
    height: 415.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 935.12,
    y: 2229.12,
    width: 295.74,
    height: 534.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1339.66,
    y: 2112.25,
    width: 307.59,
    height: 651.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1750.06,
    y: 1937.51,
    width: 307.59,
    height: 826.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2165.68,
    y: 1745.08,
    width: 307.59,
    height: 1022.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2570.42,
    y: 1633.55,
    width: 307.59,
    height: 1134.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2719.66,1259.27c-37,59.91-176.82,309.21-220,386.32a15.1,15.1,0,0,0,13.4,22.47l400.32-5.41a11.79,11.79,0,0,0,10.43-17l-188.47-385.61A9,9,0,0,0,2719.66,1259.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1900.17,1707a10,10,0,0,1-12.36-5c-5-10.11-9.56-20.57-13.66-31.12a10,10,0,0,1,5.67-12.9l.18-.06a10,10,0,0,1,12.72,5.74c3.89,10,8.26,19.95,13,29.55a10,10,0,0,1-4.55,13.34C1900.82,1706.69,1900.5,1706.83,1900.17,1707Zm-29.33-81.69a10,10,0,0,1-13.14-7c-2.62-11-4.8-22.21-6.47-33.33a10,10,0,1,1,19.7-3c1.59,10.57,3.66,21.23,6.16,31.68A10,10,0,0,1,1870.84,1625.26Zm-10.61-86.12a10.25,10.25,0,0,1-3.34.61,10,10,0,0,1-10.06-9.87c-.12-11.28.26-22.7,1.12-34a10,10,0,1,1,19.87,1.51c-.82,10.69-1.17,21.53-1.07,32.24A10,10,0,0,1,1860.23,1539.14Zm8.91-86.35A10,10,0,0,1,1856,1441.3c2.42-11,5.34-22.08,8.68-32.85a10,10,0,1,1,19,5.91c-3.18,10.23-6,20.73-8.24,31.21A10,10,0,0,1,1869.14,1452.79Zm27.94-82.19a10,10,0,0,1-12.45-13.59c4.79-10.19,10.08-20.32,15.73-30.1a10,10,0,1,1,17.26,10c-5.38,9.29-10.41,18.92-15,28.6A9.94,9.94,0,0,1,1897.08,1370.6Zm45.42-74a10,10,0,0,1-11.3-15.48c6.94-8.89,14.34-17.6,22-25.87a10,10,0,0,1,14.62,13.55c-7.29,7.86-14.32,16.13-20.91,24.58A9.94,9.94,0,0,1,1942.5,1296.64ZM2277,1148.46a9.81,9.81,0,0,1-4.17.58c-10.67-.8-21.53-1.14-32.25-1a10,10,0,0,1-.24-19.92c11.3-.14,22.73.22,34,1.06a10,10,0,0,1,2.69,19.29Zm-273.86,86.17a10,10,0,0,1-9.73-17.08c8.74-7.13,17.89-14,27.21-20.31a10,10,0,1,1,11.22,16.46c-8.85,6-17.54,12.52-25.84,19.29A9.9,9.9,0,0,1,2003.15,1234.63Zm187.14-82.82a9.69,9.69,0,0,1-1.94.5c-10.59,1.62-21.25,3.71-31.69,6.22a10,10,0,1,1-4.66-19.37c11-2.64,22.2-4.85,33.34-6.55a10,10,0,0,1,4.95,19.2Zm-114.16,35.91a10,10,0,0,1-7.84-18.3c10.11-5,20.56-9.6,31.08-13.71l.2-.08a10,10,0,0,1,7.06,18.63c-10,3.91-19.92,8.3-29.52,13C2076.79,1187.45,2076.46,1187.6,2076.13,1187.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2346,1160a9.93,9.93,0,0,1-6,.29c-5-1.3-10-2.52-15.1-3.62a10,10,0,1,1,4.25-19.47c5.31,1.16,10.66,2.44,15.89,3.81a10,10,0,0,1,.91,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2586.6,1345.4a10,10,0,0,1-12.11-4.48c-2.51-4.48-5.16-9-7.87-13.39a10,10,0,0,1,17-10.45c2.85,4.63,5.64,9.38,8.29,14.09a10,10,0,0,1-3.82,13.57A10.45,10.45,0,0,1,2586.6,1345.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2382.47,1899.52q-6.45,2.38-13,4.55a10,10,0,0,1-6.24-18.93c10.13-3.34,20.1-7.08,29.74-11.17a10,10,0,0,1,7.78,18.34C2394.75,1894.84,2388.61,1897.27,2382.47,1899.52Zm-64,17.56a9,9,0,0,1-1.64.45c-10.93,2-22.07,3.6-33.11,4.7a10,10,0,0,1-2-19.83c10.48-1,21.06-2.54,31.45-4.46a10,10,0,0,1,5.26,19.14Zm129-48.54a10,10,0,0,1-8.53-17.91c9-5.4,18-11.25,26.54-17.41a10,10,0,1,1,11.63,16.19c-9,6.48-18.44,12.65-27.95,18.33A10.4,10.4,0,0,1,2447.44,1868.54Zm-214.19,54.73a9.84,9.84,0,0,1-3.81.6c-11.1-.43-22.31-1.34-33.33-2.7a10,10,0,0,1,2.45-19.78c10.46,1.3,21.11,2.16,31.65,2.57a10,10,0,0,1,3,19.31Zm282.19-106.33a10,10,0,0,1-10.3-16.58c7.62-7.25,15.05-14.92,22.06-22.82a10,10,0,0,1,14.9,13.24c-7.39,8.31-15.2,16.39-23.23,24A10,10,0,0,1,2515.44,1816.94Zm55-65.28a10,10,0,0,1-11.72-14.9c5.88-8.76,11.45-17.88,16.57-27.09a10,10,0,0,1,17.42,9.67c-5.39,9.7-11.25,19.29-17.43,28.52A10,10,0,0,1,2570.47,1751.66Zm39.49-75.72a10,10,0,0,1-12.71-13c3.83-9.84,7.28-20,10.27-30a10,10,0,1,1,19.1,5.65c-3.14,10.63-6.77,21.27-10.8,31.63A10,10,0,0,1,2610,1675.94Zm22-82.53a10,10,0,0,1-13.28-10.84c1.59-10.44,2.74-21.06,3.43-31.57a10,10,0,1,1,19.89,1.31c-.73,11.07-1.95,22.26-3.62,33.24A9.93,9.93,0,0,1,2632,1593.41Zm3.38-85.38a9.49,9.49,0,0,1-2.73.58,10,10,0,0,1-10.65-9.22c-.75-10.5-2-21.11-3.61-31.53a10,10,0,0,1,19.69-3.1c1.73,11,3,22.14,3.8,33.2A10,10,0,0,1,2635.38,1508Zm-15.45-84-.58.19a10,10,0,0,1-12.41-6.68c-2.23-7.44-4.71-14.9-7.38-22.18q-1.45-3.95-3-7.85a10,10,0,0,1,5.64-12.91,9.84,9.84,0,0,1,12.91,5.63c1.08,2.74,2.12,5.49,3.14,8.26,2.81,7.66,5.43,15.51,7.77,23.33A10,10,0,0,1,2619.93,1424.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2148.55,1910.47a9.94,9.94,0,0,1-6,.28c-5.21-1.39-10.49-2.92-15.7-4.54a10,10,0,0,1,5.92-19c4.95,1.53,10,3,14.91,4.3a10,10,0,0,1,.87,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2121.31,1797.36a4.64,4.64,0,0,0,5.39-.46l43.18-36.7a247.16,247.16,0,0,0,79.18,11.31l31.19,47.27a4.67,4.67,0,0,0,5.05,2l65.85-16.89a4.67,4.67,0,0,0,3.48-4.14l4.58-56.45a246.77,246.77,0,0,0,63.95-48l55.53,11.38a4.65,4.65,0,0,0,4.94-2.19l34.61-58.51a4.64,4.64,0,0,0-.46-5.39l-36.7-43.18a246.88,246.88,0,0,0,11.31-79.18l47.28-31.19a4.68,4.68,0,0,0,1.94-5l-16.89-65.85a4.67,4.67,0,0,0-4.14-3.48l-56.45-4.58a246.77,246.77,0,0,0-48-64l11.38-55.53a4.65,4.65,0,0,0-2.19-4.94L2366.77,1249a4.64,4.64,0,0,0-5.39.46l-43.18,36.7a246.88,246.88,0,0,0-79.18-11.31l-31.19-47.28a4.67,4.67,0,0,0-5-1.94l-65.85,16.89a4.67,4.67,0,0,0-3.48,4.14l-4.58,56.45a246.77,246.77,0,0,0-63.95,48l-55.53-11.38a4.65,4.65,0,0,0-4.94,2.19l-34.61,58.51a4.64,4.64,0,0,0,.46,5.39L2007,1449a246.88,246.88,0,0,0-11.31,79.18l-47.28,31.19a4.67,4.67,0,0,0-1.94,5.05l16.89,65.85a4.67,4.67,0,0,0,4.14,3.48l56.45,4.58a246.77,246.77,0,0,0,48,64l-11.38,55.53a4.65,4.65,0,0,0,2.19,4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2267.57,1587.32a68.36,68.36,0,1,1,9.14-4.14A69.62,69.62,0,0,1,2267.57,1587.32Zm-41.5-113.39a54,54,0,0,0-7.08,3.21,52.16,52.16,0,1,0,7.08-3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2302.92,1679.48a171.41,171.41,0,0,1-16.49,5.13h0c-1.77.46-3.54.88-5.33,1.28a169.3,169.3,0,0,1-26.64,3.74l-.37,0-1,0-2,.1a4,4,0,0,1-3.9-2.61,4.07,4.07,0,0,1-.24-1.22,4,4,0,0,1,3.83-4.14,160.21,160.21,0,0,0,146.09-110.43,159.07,159.07,0,0,0,2.88-89.32,162.12,162.12,0,0,0-4.89-15.73,160.09,160.09,0,0,0-189.92-99.52c-85.51,22-137.18,109.33-115.25,194.81a160.08,160.08,0,0,0,42.4,74,3.83,3.83,0,0,1,.93,1.45,4,4,0,0,1-6.54,4.21,167.9,167.9,0,0,1-44.51-77.65c-23-89.75,31.28-181.49,121-204.51a168.06,168.06,0,0,1,199.38,104.48,170.92,170.92,0,0,1,5.13,16.51,168.06,168.06,0,0,1-104.5,199.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1671.59,2070.66a6.16,6.16,0,0,1-7.07-2.12c-3.11-4.19-6.13-8.54-9-12.92a6.15,6.15,0,1,1,10.31-6.72c2.72,4.17,5.61,8.32,8.57,12.32a6.15,6.15,0,0,1-1.28,8.61A6.06,6.06,0,0,1,1671.59,2070.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1647,2030.2a6.17,6.17,0,0,1-7.65-3.08,269.68,269.68,0,0,1-10.61-24.9c-.66-1.78-1.29-3.57-1.91-5.37a6.38,6.38,0,0,1,3.82-7.83,6.17,6.17,0,0,1,7.82,3.82q.88,2.58,1.82,5.13a255.74,255.74,0,0,0,10.12,23.75,6.16,6.16,0,0,1-2.83,8.23C1647.41,2030,1647.21,2030.13,1647,2030.2Zm-20.76-60.43a6.36,6.36,0,0,1-.85.25,6.16,6.16,0,0,1-7.3-4.74,267.38,267.38,0,0,1-4.83-32.4,6.15,6.15,0,0,1,12.26-1.06,256.46,256.46,0,0,0,4.61,30.9A6.16,6.16,0,0,1,1626.26,1969.77Zm-5.49-63.66a6.14,6.14,0,0,1-8.27-6,264.47,264.47,0,0,1,3.29-32.61,6.15,6.15,0,1,1,12.14,2,253.6,253.6,0,0,0-3.13,31.09A6.15,6.15,0,0,1,1620.77,1906.11Zm10.33-63.06a6.15,6.15,0,0,1-8-7.51,266.94,266.94,0,0,1,11.16-30.81,6.16,6.16,0,0,1,11.29,4.91,252.71,252.71,0,0,0-10.64,29.37A6.15,6.15,0,0,1,1631.1,1843.05Zm25.42-58.62a6.16,6.16,0,0,1-7.44-8.9,270.43,270.43,0,0,1,18.31-27.15,6.15,6.15,0,1,1,9.76,7.49,256.28,256.28,0,0,0-17.45,25.91A6.2,6.2,0,0,1,1656.52,1784.43Zm38.87-50.67a6.16,6.16,0,0,1-6.52-10.09,262.85,262.85,0,0,1,24.37-21.87,6.15,6.15,0,1,1,7.64,9.65,252.08,252.08,0,0,0-23.23,20.85A6.27,6.27,0,0,1,1695.39,1733.76Zm50.06-39.62a6.16,6.16,0,0,1-5.31-11,268.44,268.44,0,0,1,29-15.23,6.15,6.15,0,0,1,5,11.23,254.24,254.24,0,0,0-27.66,14.52A6.69,6.69,0,0,1,1745.45,1694.14Zm89.41-33.69a5.79,5.79,0,0,1-1,.29,253.93,253.93,0,0,0-26.45,6.2c-1.33.38-2.62.76-3.91,1.16a6.16,6.16,0,0,1-3.64-11.76c1.37-.42,2.75-.83,4.13-1.23a268.68,268.68,0,0,1,27.71-6.49,6.15,6.15,0,0,1,3.21,11.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1973.2,2158.52a6.15,6.15,0,0,1-4.32-11.52,255.37,255.37,0,0,0,28-12.69,6.16,6.16,0,0,1,5.75,10.89,267.94,267.94,0,0,1-29.34,13.29Zm-30,9.45c-.21.08-.42.14-.64.2a268.37,268.37,0,0,1-31.67,5.93,6.15,6.15,0,0,1-1.54-12.21,256.61,256.61,0,0,0,30.23-5.66,6.15,6.15,0,0,1,3.62,11.74Zm85.57-38.82a6.15,6.15,0,0,1-5.64-10.82,254,254,0,0,0,24.1-19.09,6.16,6.16,0,0,1,8.21,9.18,266.91,266.91,0,0,1-25.26,20A6.3,6.3,0,0,1,2028.74,2129.15Zm-148,46.62a6.17,6.17,0,0,1-2.11.38,264.33,264.33,0,0,1-32.19-1.89A6.15,6.15,0,0,1,1848,2162a251.87,251.87,0,0,0,30.69,1.8,6.15,6.15,0,0,1,2.14,11.93Zm194.75-88.55a6.15,6.15,0,0,1-6.76-9.82,254,254,0,0,0,18.79-24.31,6.16,6.16,0,1,1,10.18,6.93A267.09,267.09,0,0,1,2078,2085.5,6,6,0,0,1,2075.54,2087.22Zm35.37-51.92a6.15,6.15,0,0,1-7.59-8.6,259.37,259.37,0,0,0,12.44-28.11,6.16,6.16,0,0,1,11.54,4.29,269.39,269.39,0,0,1-13.05,29.47A6.16,6.16,0,0,1,2110.91,2035.3Zm21.91-58.92a6,6,0,0,1-3.55.21,6.16,6.16,0,0,1-4.55-7.42,251.69,251.69,0,0,0,5.34-30.27,6.15,6.15,0,0,1,12.23,1.39,264.08,264.08,0,0,1-5.6,31.75A6.13,6.13,0,0,1,2132.82,1976.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1818.09,2168.2a6.07,6.07,0,0,1-3.59.19c-5.12-1.26-10.21-2.69-15.16-4.22a6.16,6.16,0,1,1,3.66-11.76c4.71,1.47,9.58,2.83,14.46,4a6.15,6.15,0,0,1,.63,11.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1795.48,2091.82a3.12,3.12,0,0,0,3.6-.31L1828,2067a165.42,165.42,0,0,0,53,7.57l20.88,31.63a3.1,3.1,0,0,0,3.37,1.3l44.06-11.3a3.12,3.12,0,0,0,2.34-2.77l3.06-37.78a164.88,164.88,0,0,0,42.79-32.14l37.16,7.62a3.12,3.12,0,0,0,3.3-1.47l23.17-39.15a3.14,3.14,0,0,0-.31-3.61L2036.22,1958a165.48,165.48,0,0,0,7.57-53l31.63-20.87a3.12,3.12,0,0,0,1.3-3.38l-11.3-44.06a3.11,3.11,0,0,0-2.77-2.33l-37.77-3.06a165.19,165.19,0,0,0-32.15-42.8l7.62-37.15a3.14,3.14,0,0,0-1.47-3.31l-39.15-23.16a3.12,3.12,0,0,0-3.61.3l-28.89,24.57a164.88,164.88,0,0,0-53-7.57l-20.87-31.64a3.11,3.11,0,0,0-3.37-1.3l-44.07,11.31a3.11,3.11,0,0,0-2.33,2.76l-3.06,37.78a165.38,165.38,0,0,0-42.8,32.14l-37.15-7.61a3.12,3.12,0,0,0-3.31,1.46l-23.16,39.16a3.11,3.11,0,0,0,.31,3.6l24.56,28.9a165.1,165.1,0,0,0-7.57,53l-31.64,20.87a3.14,3.14,0,0,0-1.3,3.38l11.31,44.06a3.1,3.1,0,0,0,2.76,2.33l37.78,3.07a165.33,165.33,0,0,0,32.14,42.79l-7.61,37.16a3.09,3.09,0,0,0,1.47,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1893.57,1952.06a46.6,46.6,0,1,1,6.28-2.84A47.64,47.64,0,0,1,1893.57,1952.06Zm-27.76-75.88a34.24,34.24,0,1,0,28.16,62.23h0a34.24,34.24,0,0,0-28.16-62.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1918.09,2016.24a117.14,117.14,0,0,1-34.61,7l-1.06,0a6.17,6.17,0,0,1-6-4,6.54,6.54,0,0,1-.37-1.89,6.17,6.17,0,0,1,5.91-6.39,103.48,103.48,0,0,0,21.83-3.2h0l1.18-.31a102.59,102.59,0,0,0,44.3-24.73,104,104,0,0,0,17.47-21.76l.12-.19.36-.61a102.94,102.94,0,0,0,11.19-78.51,104.56,104.56,0,0,0-3.17-10.18,103.62,103.62,0,0,0-197.56,61.68,104.48,104.48,0,0,0,3.13,10,103.18,103.18,0,0,0,24.32,37.84,5.9,5.9,0,0,1,1.44,2.25,6.15,6.15,0,0,1-10.1,6.5,115.69,115.69,0,0,1-27.21-42.33,117.25,117.25,0,0,1-3.5-11.25,115.93,115.93,0,0,1,221-69q2,5.57,3.54,11.39A116.09,116.09,0,0,1,1918.09,2016.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M610.14,1110.45a448.44,448.44,0,0,0,186.45,187c151.64,80.81,328.67,66.14,462.26-23L1008.46,899.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1258.85,1274.5a452.12,452.12,0,0,0,181.84-247.23L1008.46,899.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1440.69,1027.27a450.27,450.27,0,0,0-15-297.17L1008.46,899.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M973.77,881.41l29.93-449.63c-171.34-11.31-341.52,76.37-427.52,237.76-73,137-68.09,294.73-.74,422.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1425.74,730.1A450.35,450.35,0,0,0,1357,614.23c-130.12,111.4-348.49,285.67-348.49,285.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1357,614.23a451.75,451.75,0,0,0-318.55-164L1008.46,899.9S1226.83,725.63,1357,614.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1646.76,2491.49c-.88-9.8-11-18.21-28-24.88,18.36-10.33,28.47-21.32,27.52-32-2.89-32.34-105.51-49.59-229.22-38.54s-221.65,46.22-218.76,78.55c.88,9.81,11,18.22,28,24.88-18.36,10.34-28.47,21.33-27.52,32,.88,9.81,11,18.22,28,24.88-18.36,10.33-28.47,21.32-27.51,32,.87,9.81,11,18.21,28,24.88-18.36,10.33-28.47,21.32-27.51,32,1.27,14.3,22.08,25.64,55.57,32.9a287.41,287.41,0,0,0,1.15,34.95c5.36,59.58,72.83,105.75,161.53,105s164.92-65.17,165.28-125a302.48,302.48,0,0,0-2.07-39c42.31-14.54,68-32.07,66.51-48.85-.87-9.81-11-18.22-28-24.88,18.35-10.33,28.47-21.32,27.51-32-.87-9.81-11-18.22-28-24.88C1637.6,2513.17,1647.71,2502.18,1646.76,2491.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1362.31,2690.14c-36.77.32-70.43-2.1-98.27-7.18a3,3,0,0,1,1.06-5.85c43.57,7.95,101.67,9.28,163.62,3.75,50.69-4.53,98-13.12,137-24.84a3,3,0,1,1,1.72,5.69c-39.3,11.84-87.08,20.51-138.16,25.07C1406.24,2688.84,1383.75,2690,1362.31,2690.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1362.43,2633.19c-47.77.42-90.49-3.71-120.68-12a3,3,0,0,1,1.58-5.73c43,11.84,112.13,15,184.9,8.53,72-6.43,139-21.62,179.35-40.65a3,3,0,0,1,2.54,5.38c-40.93,19.31-108.73,34.71-181.36,41.2C1406.09,2631.92,1383.76,2633,1362.43,2633.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1361.33,2576.35c-51.58.45-96.76-4.44-127.22-14.19a3,3,0,0,1,1.81-5.66c42.4,13.57,114.1,17.53,191.82,10.59,72-6.43,139-21.63,179.35-40.66a3,3,0,0,1,2.54,5.38c-40.93,19.31-108.73,34.71-181.36,41.2C1405.25,2575.07,1382.74,2576.17,1361.33,2576.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1361.23,2519.44c-40.91.35-78.15-2.64-107.13-8.81a3,3,0,0,1,1.24-5.82c43.58,9.29,106.24,11.25,171.9,5.39,71.34-6.37,138-21.41,178.45-40.22a3,3,0,1,1,2.5,5.39c-41,19.09-108.43,34.32-180.42,40.75C1405,2518.15,1382.63,2519.25,1361.23,2519.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1112.9,2208.93a418.54,418.54,0,0,0-76.23-145.72c-74.5-92.24-196.35-280.09-213.38-537.76-24.76-374.79,306.18-565.4,609.87-542.54s605.08,246.24,575.32,595.36c-18.32,214.82-137,378.67-225.69,472.94-56.29,59.87-96.18,132.94-117.43,212.32-26,97.15-88.85,218.49-240.63,227.16C1228.34,2501.92,1145.15,2319.48,1112.9,2208.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1474.28,2415.48l100.21-691.54c2.07-14.29,9-23.93,15.5-21.54s10.07,15.91,8,30.2c0,.38-.13.85-.19,1.22l-115,685.26c-.86,5.15-3.45,8.42-5.77,7.31S1473.56,2420.47,1474.28,2415.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1364.1,2421.92,1252,1732.21c-2.31-14.25-9.42-23.77-15.87-21.27s-9.79,16.09-7.47,30.34c.06.37.14.84.21,1.22l126.86,683.16c1,5.14,3.6,8.36,5.9,7.21S1364.91,2426.89,1364.1,2421.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1573.22,1664.65c-2.73-4.32-9-5.88-14-3.5l-58.89,28.13-21-58.3a12.59,12.59,0,0,0-7.26-7.17c-6.82-2.74-14.94-.17-18.12,5.76l-.1.19L1406,1718.83,1359.79,1593l-.08-.21a14.39,14.39,0,0,0-6.89-7.64c-7.6-4.07-17.58-2-22.29,4.59l-67.17,94.16c-2.73,3.86-1.73,9,2.5,11.79a11.39,11.39,0,0,0,14.44-1.69l59.28-67.28,54.92,119.59,0,.09a9.54,9.54,0,0,0,4.79,4.61c5.08,2.33,11.38.64,14.07-3.77l51.28-83.9,19.94,42,.18.38a8.64,8.64,0,0,0,.49.89c2.73,4.31,9,5.87,14,3.49l69.9-33.4C1574.13,1674.38,1576,1669,1573.22,1664.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1784.37,1967.71a19,19,0,0,1-15.53-30.23,779.25,779.25,0,0,0,48.27-74.71,19,19,0,1,1,33.11,18.74,816,816,0,0,1-50.62,78.38A19,19,0,0,1,1784.37,1967.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1870.43,1817.05a19,19,0,0,1-17.67-26.46c109-257.12,11.41-470.93,10.4-473.06a19,19,0,1,1,34.46-16.15c4.36,9.32,105.75,231.47-9.82,504.06A19.06,19.06,0,0,1,1870.43,1817.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M590.63,1376.43s-34.33,16.7-40.64,35.88c-5.07,15.39-43,17.38-46.78,47.65-1.94,15.63-13.5,28.15-29.07,30.54-38.78,5.94-98.53,26.07-108.09,93.39-7.3,51.39,18.9,70.87,46.39,77.61,20.19,5,33.61,24.6,29.52,45-3.91,19.55,1.93,42.16,35.8,60,75.91,40,151.71-94.89,151.71-94.89L645,1436Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1003.66,1320.57s-151.55,239.72-331.77,286c0,0,35.11,100,62.22,111.47,0,0,221.72-185,278.7-363.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M278.63,2853.83l-4.92,40.38a16.67,16.67,0,0,1-14.63,14.59c-12.94,1.48-33.71,3-54,.85a14.29,14.29,0,0,1-12-18.53c4.95-15.59,14-39,27.08-52.76h44.8A13.81,13.81,0,0,1,278.63,2853.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M629.47,2380.8l7.56,44.47s-25.32,256.46-29.82,359.05a80.28,80.28,0,0,0,11.9,45.68l44,71.49-111.89-66L549,2821.82l18.32-25.19-24-287.3a88.12,88.12,0,0,1,10-48.75l23.14-43.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M670.5,2911.85H634.79a21.52,21.52,0,0,1-17.06-8.36c-11.13-14.47-34.19-42.69-45.22-43.42-14.85-1-13,51.78-13,51.78h-8.32l-10.54-65.58a38.84,38.84,0,0,1,20.37-40.58s3.4,25.1,21.8,36.2,74.87,50.86,74.87,50.86a51,51,0,0,1,14.52.38C683.52,2895.17,682,2911.85,670.5,2911.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M476.22,2401.92s-148.33,281.36-171.9,345.6-31.84,117.83-32.16,122.9c-.49,7.93-10.36,15.54-37.54,15.54-14,0-20.9-5.63-24.27-11.07a15.85,15.85,0,0,1-.6-15.35c8.58-17.36,35.81-72.85,45.89-98,12-30.05,37.94-166.23,52.15-213.58s30.25-98.71,92.11-146C399.9,2401.92,442.36,2360.33,476.22,2401.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M569.92,1940.9c38.26-162.13-58.67-253.83-58.67-253.83,61.16-58.7,172.59-85.42,172.59-85.42s106.34,77.74,93.72,138.59c-7.39,35.66-74.74,213.6-74.74,213.6S640.55,1983.32,569.92,1940.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M485.09,2021.16c15.57-46.9,84.83-80.26,84.83-80.26,70.63,42.42,132.9,12.94,132.9,12.94s14,53.39,4.33,103S637,2425.27,637,2425.27c-95.29,19.31-241.84-19.42-241.84-19.42C455.88,2298.09,469.52,2068.07,485.09,2021.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M614.33,1494.51l-31.11,139.73c-3,12.31,8.25,10.29,20.69,8,20.38-3.84,46.64-11.76,55.42-27.61a15.13,15.13,0,0,0,1.59-5.27l13.37-96.89a17.4,17.4,0,0,0-10.19-18.29l-25.79-11.44A17.41,17.41,0,0,0,614.33,1494.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M511.25,1687.07S211,1984.3,646.44,1865.65c0,0,5-37.57-1.51-36.92-141.21,14.09-200.27,46.41-85.48-64.89,4.06-3.94,2.8-18.79.19-23.8C551.69,1724.77,533.52,1694.45,511.25,1687.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M673.91,1367.14s33.12,22.41,47.35,79.5-8.89,77.57-32.6,76.32-58.08-8.59-87.86-49.55S630.52,1339.74,673.91,1367.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M630.84,1450.39s-12.14-81.81,55.78-69.29l13.73,14.29s33.25-37.44-3.54-65.74S609,1308.6,580.72,1360.12s-38.49,87.73-14.82,119.74,41.48,4.56,41.48,4.56-10.86-27.71-1.85-39.6,20.63,6.92,20.63,6.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M621.55,1457.39s-6-42.09-27.48-30.05,7.74,39.31,19.47,48.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1002.62,1369.92c.46,4.94-17.93,8.36-23.78-12.72,1.61-9.15,4.47-49.23,11.48-55.46,37.38-33.16,104-70.47,104-70.47,7.45,11.38-2.33,18.88-2.33,18.88l-33.27,22.45c3.48,11.5,8.54,21.66,9.11,34.78a38.91,38.91,0,0,1-9.83,27.21c-6.62,7.56-15.54,17.33-23.57,24.75C1019.25,1373.37,1002.62,1369.92,1002.62,1369.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1020.69,1353.58l-5.08-2.09c.67-1.65,16.64-40.44,24.36-48.51,2.94-3.06,4.35-5.69,4.22-7.8a5.5,5.5,0,0,0-1.71-3.42l-26.92,14.39-11.89,18.62-4.63-3L1011.7,1302l31.53-16.86,1.43,1.16c3.18,2.6,4.83,5.4,5,8.56.23,3.77-1.64,7.67-5.73,11.94C1038.13,1312.86,1025.19,1342.62,1020.69,1353.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M628.89,1927l72.66-253.76a7.41,7.41,0,0,1,6.26-5.33c13.17-1.53,51.31-5.85,95.36-9.57,53.06-4.49,114.67-8.13,151.49-5a7.43,7.43,0,0,1,6.07,10.68c-20.94,42.36-107.06,214.66-150.19,271.11a7.45,7.45,0,0,1-6,2.94L636,1936.43A7.43,7.43,0,0,1,628.89,1927Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M810.71,1636.3l52.68-8.78a3.78,3.78,0,0,1,4.21,4.91l-5.21,15.81a3.8,3.8,0,0,1-3.09,2.56l-50.7,6.77a3.78,3.78,0,0,1-4.18-4.61l3.23-13.79A3.77,3.77,0,0,1,810.71,1636.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M771.26,1680.9l4.34-22.61a5.22,5.22,0,0,1,4.6-4.21l106.41-10.8a5.23,5.23,0,0,1,5.61,6.42l-6.76,28.17a5.25,5.25,0,0,1-4.82,4l-104,5.23A5.22,5.22,0,0,1,771.26,1680.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M646.44,1865.65s-10.12-41.62-6-56.39,12-33.75,38.37-29.53,57.47,15.33,57.47,15.33-1.57,19.23-21.61,13l12.43,9.61s-1.78,15.4-18.71,7.17l11.56,12.76s-7.27,12.65-19.72,4.53S681.76,1870.66,646.44,1865.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 2135.49,
    cy: 866.01,
    r: 557.75,
    transform: "translate(13.11 1763.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 2135.49,
    cy: 866.01,
    r: 476.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2135.49,1365.87c-275.62,0-499.85-224.23-499.85-499.86s224.23-499.86,499.85-499.86S2635.35,590.38,2635.35,866,2411.11,1365.87,2135.49,1365.87Zm0-975.88c-262.47,0-476,213.54-476,476s213.54,476,476,476,476-213.54,476-476S2398,390,2135.49,390Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 2135.49,
    cy: 866.01,
    r: 290.2,
    transform: "translate(13.11 1763.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2135.49,1180.06c-173.16,0-314-140.89-314-314s140.88-314,314-314,314.05,140.88,314.05,314S2308.66,1180.06,2135.49,1180.06Zm0-580.41c-146.87,0-266.36,119.49-266.36,266.36s119.49,266.36,266.36,266.36S2401.85,1012.88,2401.85,866,2282.37,599.65,2135.49,599.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 2135.49,
    cy: 866.01,
    r: 112.43,
    transform: "translate(13.11 1763.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2135.49,1002.29c-75.14,0-136.27-61.14-136.27-136.28s61.13-136.28,136.27-136.28S2271.77,790.87,2271.77,866,2210.64,1002.29,2135.49,1002.29Zm0-224.87a88.59,88.59,0,1,0,88.6,88.59A88.69,88.69,0,0,0,2135.49,777.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 2524.82,
    y: 77.81,
    width: 21.21,
    height: 803.1,
    transform: "translate(3989.31 2611.11) rotate(-135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M2254.61,719.61c8.6-8.6,49.16,32,40.56,40.56L2144.74,878.44c-5.56,4.37-12.76-2.83-8.39-8.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2826.54,203.24l76.39,7.6L2798.06,315.72a162.15,162.15,0,0,1-130.69,46.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2811.54,188.25l-7.59-76.4L2699.07,216.73a162.16,162.16,0,0,0-46.7,130.68h0Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectmanagement3);
export default __webpack_public_path__ + "static/media/projectmanagement_3.69b038a3b93d2dac26624f3419f34958.svg";
export { ForwardRef as ReactComponent };